import { render, staticRenderFns } from "./ResponseBody.vue?vue&type=template&id=3f1f72ed&scoped=true&"
import script from "./ResponseBody.vue?vue&type=script&lang=js&"
export * from "./ResponseBody.vue?vue&type=script&lang=js&"
import style0 from "./ResponseBody.vue?vue&type=style&index=0&id=3f1f72ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1f72ed",
  null
  
)

export default component.exports